import Switch from 'rc-switch';
import styled from 'styled-components';
import 'rc-switch/assets/index.css';

export const SwitchStyled = styled(Switch)`
  &.rc-switch {
    border: none;
    &::after {
      top: 3px;
      left: 3px;
      width: 16px;
      height: 16px;
    }
    &-checked {
      background: linear-gradient(270deg, #8468FF 0%, #6D8EFF 100%);
      &::after {
        left: 24px;
      }
    }
    &, &:focus {
      outline: none;
      box-shadow: 0 3px 5px rgba(89, 102, 137, 0.32);
    }
  }
`;
